export const convertToGeoJSON = (data: any[]) => {
  let new_data = [];
  let i = 0;
  for (let datum of data) {
    let geoJSON_object = {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [parseFloat(datum.longitude), parseFloat(datum.latitude)],
      },
      properties: { ...datum, index: i },
    };
    new_data.push(geoJSON_object);
    i++;
  }
  let geoJSON = { type: "FeatureCollection", features: new_data };
  return geoJSON;
};
